var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_18570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 0.386719V3.00364H12.8697",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9044 8.56093V3.00364L9.65579 0.351562H1.72852V16.1509H8.77798",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71484 9.16748H9.76488",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71387 11.1384H6.10435",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71387 13.1099H6.10435",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71387 7.19604H10.9162",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71387 5.22485H10.9162",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4395 16.2886L16.8169 17.6484",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1604 17.5882C14.6981 17.5882 16.7553 15.5572 16.7553 13.0519C16.7553 10.5466 14.6981 8.51562 12.1604 8.51562C9.62265 8.51562 7.56543 10.5466 7.56543 13.0519C7.56543 15.5572 9.62265 17.5882 12.1604 17.5882Z",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7298 13.0841C13.383 12.7704 13.6604 11.9911 13.3494 11.3435C13.0384 10.6959 12.2567 10.4252 11.6036 10.7389C10.9504 11.0526 10.673 11.8319 10.984 12.4795C11.295 13.1271 12.0767 13.3978 12.7298 13.0841Z",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8752 14.0019C13.9075 13.5731 13.5673 13.2095 13.1353 13.2109L11.1894 13.2174C10.7572 13.2189 10.4147 13.5847 10.4441 14.0133L10.5076 15.2243L13.8036 15.2134L13.8752 14.0019Z",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_18570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.272461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadDetails);
export default __webpack_public_path__ + "static/media/leadDetails.69cd513ef4e729a518c1f0d4db3aff17.svg";
export { ForwardRef as ReactComponent };